import { useTheme } from '@mui/material';

import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    pageContent: {
      margin: '0 320px 0 20px',
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
    },
    greetingBox: {
      padding: theme.spacing(1, 2),
      backgroundColor: cssColorHexToRgbA(theme.palette.background.paper, 0.9),
    },
    widgetBox: {
      width: '100%',
      maxWidth: '500px',
      height: '500px',
    },
    listItem: {
      border: '1px solid #ddd',
      borderRadius: '5px',
      marginBottom: '10px',
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
};
